import { render, staticRenderFns } from "./OrderTasks.vue?vue&type=template&id=30dcaa79&scoped=true"
import script from "./OrderTasks.vue?vue&type=script&lang=js"
export * from "./OrderTasks.vue?vue&type=script&lang=js"
import style0 from "./OrderTasks.vue?vue&type=style&index=0&id=30dcaa79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dcaa79",
  null
  
)

export default component.exports